/**
 * Gets the currently active chain
 *
 * @param {AlchemyAccountsConfig} config the account config object
 * @returns {Chain} the currently active chain
 */
export function getChain(config) {
    return config.store.getState().chain;
}
//# sourceMappingURL=getChain.js.map